import PropTypes from 'prop-types';

import { deconstructMapping } from './mapping';

export function propTypesFromConnect(mapping) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var propTypes = Object.assign({}, mapping.propTypes || mapping.passedProps || {});

  if (mapping.props) {
    var propsArray = deconstructMapping(mapping.props);

    if (!propsArray) {
      return;
    }

    propsArray.forEach(function (_ref) {
      var logic = _ref[0],
          from = _ref[1],
          to = _ref[2];

      if (logic && logic.propTypes) {
        var propType = logic.propTypes[from];

        if (propType) {
          propTypes[to] = propType;
        } else if (from !== '*') {
          console.error('[KEA-LOGIC] prop type for "' + from + '" missing for logic:', logic);
          console.trace();
        }
      }
    });
  }

  if (mapping.actions) {
    var actionsArray = deconstructMapping(mapping.actions);

    if (!actionsArray) {
      return;
    }

    propTypes.actions = {};

    actionsArray.forEach(function (_ref2) {
      var logic = _ref2[0],
          from = _ref2[1],
          to = _ref2[2];

      var actions = logic && logic.actions ? logic.actions : logic;

      if (actions[from]) {
        propTypes.actions[to] = PropTypes.func;
      } else {
        console.error('[KEA-LOGIC] action "' + from + '" missing for logic:', logic);
        console.trace();
      }
    });

    propTypes.actions = PropTypes.shape(propTypes.actions);
  }

  if (extra) {
    Object.assign(propTypes, extra);
  }

  return propTypes;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kea/es/kea/connect/prop-types.js
// module id = 198
// module chunks = 0